import { Typography, Grid, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { BottomNavigation } from './bottomNavigation';
import { CustomField } from './custom-field';
import { Formik, Form } from 'formik';
import { ACTIONS } from '@/components/layouts/layout.props';
import * as Yup from 'yup';

const UserInfoSlide: any = ({
  design,
  fields,
  next,
  prev,
  lastSlideIndex,
  submissionCount,
  dispatch,
  slideIndex,
  totalQuestions,
}: any) => {
  const [initialValues, setInitialValues] = useState([]);

  useEffect(() => {
    const defaultValues = fields.map((field: any) => {
      return {
        [field.id]: JSON.parse(field.defaultValue),
      };
    });
    setInitialValues(defaultValues);
  }, [fields]);

  const handleSaveField = (values: any) => {
    for (var index in fields) {
      const fieldObj = {
        field: fields[index].id,
        data: JSON.stringify(
          values[fields[index].id] !== undefined &&
            values[fields[index].id] !== null
            ? values[fields[index].id]
            : '-'
        ),
      };

      dispatch({
        type: ACTIONS.ADD_SUBMISSION,
        payload: fieldObj,
      });
    }
  };

  const handleNextSlide = (values: any, validateForm: any) => {
    validateForm().then((errors: any) => {
      if (Object.keys(errors).length === 0) {
        return next();
      }
      return null;
    });
  };

  const formValidationSchema = Yup.object().shape({
    ['J7NL5V']: Yup.string().required('First Name required'),
    ['E1lqW7']: Yup.string().required('Last Name required'),
    ['pVgr6j']: Yup.string()
      .email('Invalid email format')
      .required('Email is Required'),
    ['Bjawy1']: Yup.string().required('Level Title is required'),
    ['Bjar6V']: Yup.string().required('Craft is required'),
    ['J73Lkj']: Yup.string().required('Office Alignment is required'),
  });

  return (
    <Grid
      container
      spacing={2}
      sx={{
        margin: '0px',
      }}
    >
      <Grid>
        <Typography
          sx={{ color: '#fff', paddingTop: '80px', fontSize: '20px' }}
        >
          Note: DO NOT use your browser&apos;s &apos;back&apos; button or &apos;refresh&apos; the page as
          your place and data will be lost. Please navigate using the &apos;Previous&apos;
          and &apos;Next&apos; CTAs only.
        </Typography>
        <Typography
          sx={{ typography: { sm: 'h4', xs: 'h5' } }}
          style={{
            color: design.colors.question,
            fontFamily: 'Open Sans',
            fontSize: '50px',
            fontWeight: '400',
            paddingTop: '50px',
          }}
        >
          Tell us a bit{' '}
          <span
            style={{
              fontWeight: '800',
            }}
          >
            about yourself
          </span>
        </Typography>
      </Grid>

      {initialValues && (
        <Formik
          initialValues={{
            ...initialValues,
            submissionCount: submissionCount,
          }}
          onSubmit={handleSaveField}
          enableReinitialize={true}
          validationSchema={formValidationSchema}
          validateOnBlur={true}
          validateOnChange={true}
        >
          {({ values, handleChange, errors, validateForm }) => (
            <Form
              className='form-slide'
              style={{
                width: '100%',
                display: 'flex',
                margin: '14px',
                justifyContent: 'flex-start',
              }}
            >
              {fields.length && (
                <Grid
                  container
                  spacing={2}
                  sx={{ marginTop: '60px', padding: '12px' }}
                >
                  {[0, 2, 3, 4, 5, 1].map((index) => {
                    return (
                      <Grid item md={6} xs={12} key={index}>
                        <CustomField
                          field={fields[index]}
                          focus={false}
                          design={design}
                          next={next}
                          prev={prev}
                          slideIndex={slideIndex}
                          lastSlideIndex={lastSlideIndex}
                          handleChange={handleChange}
                          values={values}
                          errors={errors}
                          totalQuestions={totalQuestions}
                        />
                      </Grid>
                    );
                  })}
                </Grid>
              )}
              <Grid
                container
                display='flex'
                maxWidth='xl'
                sx={{ alignItems: 'flex-start' }}
              >
                <BottomNavigation
                  errors={errors}
                  design={design}
                  next={() => handleNextSlide(values, validateForm)}
                  prev={prev}
                  slideIndex={slideIndex}
                  values={values}
                  lastSlideIndex={lastSlideIndex}
                  nextButtonText="Let's Get Started"
                />
              </Grid>
            </Form>
          )}
        </Formik>
      )}
    </Grid>
  );
};

export default UserInfoSlide;
